import { BackIcon } from '../../Brand/Icon';
import React from "react";
import { Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ButtonBack({ fallbackPath = '/', onClick, label }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    
    const handleBack = () => {
        // Приоритет 1: из state
        if (location.state?.searchReturn && location.state?.from) {
            navigate(location.state.from, { replace: true, state: location.state.searchReturn });
        } else if (location.state?.from) {
            navigate(location.state.from, { replace: true });
        } 
        // Приоритет 2: назад по истории
        else if (window.history.state?.idx > 0) {
            navigate(-1, { replace: true });
        } 
        // Приоритет 3: fallback
        else {
            navigate(fallbackPath, { replace: true });
        }
    };
    
    return (
        <Button aria-label={label || t('common.back', { defaultValue: 'Back' })} onClick={onClick || handleBack} icon={<BackIcon />}/>
    );
}
